import React from 'react';
import './ProjectList.css';

const ProjectList = ({ projects, onEdit, onToggleDraft }) => {

  const handleDraftToggle = async (e, project) => {
    e.stopPropagation(); // Prevent opening the edit modal
    if (onToggleDraft) {
      await onToggleDraft({...project, isDraft: !project.isDraft});
    }
  };

  const handleFeaturedToggle = async (e, project) => {
    e.stopPropagation(); // Prevent opening the edit modal
    if (onToggleDraft) {
      // Use the same handler but toggle featured instead
      await onToggleDraft({...project, featured: !project.featured});
    }
  };


  if (projects.length === 0) {
    return (
      <div className="empty-projects">
        <h3>No projects found</h3>
        <p>Click "Add New Project" to create your first project.</p>
      </div>
    );
  }

  return (
    <div className="project-list">
      <div className="list-header">
        <h2>Projects ({projects.length})</h2>
      </div>
      
      <div className="projects-grid">
        {projects.map((project) => (
          <div 
            key={project.id} 
            className={`project-card clickable ${project.isDraft ? 'draft' : ''}`}
            onClick={() => onEdit(project)}
          >
            <div className="project-image">
              {project.imageUrl ? (
                <img 
                  src={project.thumbnailUrl || project.imageUrl}
                  alt={project.title}
                />
              ) : (
                <div className="no-image">No Image</div>
              )}
              {project.featured && (
                <div className="featured-badge">★ Featured</div>
              )}
              {project.isDraft && (
                <div className="draft-badge">Draft</div>
              )}
            </div>
            
            <div className="project-info">
              <div className="project-header">
                <h3>{project.title}</h3>
              </div>
              
              <div className="project-meta">
                <div className="project-stats">
                  <span>Images: {(project.additionalImages?.length || 0) + (project.imageUrl ? 1 : 0)}</span>
                  <span>Videos: {project.videoUrls?.length || 0}</span>
                  <span>Date: {project.projectDate ? new Date(project.projectDate).toLocaleDateString() : 'Not set'}</span>
                </div>
                
                <div className="quick-toggles">
                  <button
                    onClick={(e) => handleFeaturedToggle(e, project)}
                    className={`quick-toggle ${project.featured ? 'featured' : 'not-featured'}`}
                    title={project.featured ? 'Remove from featured' : 'Make featured'}
                  >
                    {project.featured ? '★' : '☆'}
                  </button>
                  
                  <button
                    onClick={(e) => handleDraftToggle(e, project)}
                    className={`quick-toggle ${project.isDraft ? 'draft' : 'published'}`}
                    title={project.isDraft ? 'Click to publish' : 'Click to make draft'}
                  >
                    {project.isDraft ? '📄' : '🌐'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectList;